import { z } from 'zod';

import { updateAssignmentPayloadSchema } from './update-assignment-payload';

export type UpdateAssignmentsPayload = z.output<typeof updateAssignmentsPayloadSchema>;
export type UpdateAssignmentsPayloadDTO = z.input<typeof updateAssignmentsPayloadSchema>;

export const updateAssignmentsPayloadSchema = z.array(
  updateAssignmentPayloadSchema.extend({
    id: z.uuid(),
  }),
);
